import { useSyncExternalStore } from 'react';

/**
 * Largura (px) da coluna de conteúdo do Shell — o que SOBRA pra página
 * depois do menu, da coluna "Ditar documentos" e da agenda encaixada. O
 * Shell mede (ResizeObserver) e publica aqui.
 *
 * É ela, e não a janela, que decide se o Amplo cabe: numa tela de 1700px com
 * o ditado e a agenda abertos sobram ~750px — largura de tablet — e a media
 * query (≥1280px) continuava montando o cockpit (pedido do Leopoldo,
 * 26/10/2026).
 */

/** Abaixo disto de conteúdo a ficha não cabe no Amplo (lista + editor lado a
 *  lado): abas e colunas cortam e os botões do editor se sobrepõem. */
export const AMPLO_MIN_CONTENT_PX = 1000;

let largura: number | null = null;
const ouvintes = new Set<() => void>();

/** `null` = fora do Shell (sem medida). */
export function setContentWidth(px: number | null): void {
  if (px === largura) return;
  largura = px;
  ouvintes.forEach((f) => f());
}

function assinar(f: () => void) {
  ouvintes.add(f);
  return () => {
    ouvintes.delete(f);
  };
}

/**
 * O conteúdo tem pelo menos `minPx`? Sem medida (fora do Shell, testes),
 * responde sim — a decisão fica com a media query, como antes. Só re-renderiza
 * quando a resposta muda, não a cada pixel da animação das colunas.
 */
export function useContentFits(minPx: number): boolean {
  return useSyncExternalStore(
    assinar,
    () => largura == null || largura >= minPx,
    () => true,
  );
}
